import React, { useRef } from 'react'
/** @jsxImportSource @emotion/react */
import { css} from '@emotion/react'
import { Space,Table ,DatePicker,Pagination, Select, Input, Button, Modal, Form} from 'antd';
import { useState } from 'react';
import { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import CheckIcon from '@mui/icons-material/Check';
import { ExclamationCircleFilled } from '@ant-design/icons';

import axios from '../apiClient';
import Alert from '../alert';
import moment from 'moment/moment';
import Loader from '../loader';

const { TextArea } = Input;

const {RangePicker} = DatePicker;

export default function DebtList() {

  const [debts, setDebts] = useState([]);
  const [page, setPage] = useState(1);
  const [total,setTotal] = useState();
  const [loading,setLoading] = useState(true)
  const [paymentMethods,setPaymentMethods] = useState();
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const location = useLocation();
  const startOfDay = moment().subtract(30,'day').format('YYYY-MM-DD HH:mm:ss');
  const endOfTmr = moment().add(1, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss');
  const [date,setDate] = useState({startDate: startOfDay,endDate: endOfTmr})
  const [form] = Form.useForm();
  const masterName = useRef("");
  masterName.current = location.state?.name

  console.log("location",location.state)


  async function fetchData() {
    const masterId =  location.state?.id;
    setLoading(true)
    let res = await axios.get(`/wallet/getDebtByMasterId?masterId=${masterId}&current=${page}&pageSize=10`)
    if (res.code != 200) {
        if(res.code == 404){
            setLoading(false)
            return
        }
        setErrorMsg({ code: res.code, msg: res.message })
        setOpenAlert(true)
        setLoading(false)
        return
    }
    setDebts(res.data?.debt)
    setTotal(res.data?.pagination?.total)
    setLoading(false)
  }

  const getPaymentMethod = async () => {
    const res = await axios.get(`/member/getPaymentChannelList`);
    if(res.code == 200){
      const arr = res?.data?.map(v=> {
        return {value: v?.channel_name,label: v?.display_name};
      })
      setPaymentMethods(arr);
    }
  }

  const handleCloseAlert = () => setOpenAlert(false)

  const handlePageChange = (page) => setPage(page)

  const handleDateChange = async (v,dateString) => setDate({startDate: `${dateString[0]} 00:00:00`,endDate: `${dateString[1]} 23:59:59`});

  useEffect(()=> {
      fetchData()
  },[date,page])

  useEffect(()=> {
    getPaymentMethod();
  },[])

  const setDefaultCopyText = () => {
   
  }
  const columns = [
      {
        title: 'Name',
        key: 'loss',
        render : () => masterName.current
      },
      {
        title: ' Before',
        key: 'before',
        dataIndex: 'before',
        render : (amount) => Number(amount).toLocaleString()
      },
      {
        title: 'Adjustment',
        key: 'adjustment',
        dataIndex: 'adjustment',
        render : (amount) => Number(amount).toLocaleString()
      },
      {
        title: 'After',
        key: 'after',
        dataIndex: 'after',
        render : (amount) => Number(amount).toLocaleString()
      },
      {
        title: 'Date',
        key: 'created_at',
        dataIndex: 'created_at',
        render: (date) => moment(date).format("DD-MM-YYYY h:mm A")
      },
  ];

  const { confirm } = Modal;
  const showTextArea = () => {
    setDefaultCopyText();
    confirm({
      mask: false,
      centered: true,
      maskClosable: true, 
      // cancelButtonProps: { style: { display: 'none' } },
      okText: "Receive",
      title: "Input Received Amount",
      icon: <ExclamationCircleFilled />,
      onOk(close) {
        handleReceive(close)
      },
      content: 
      <Form
      name="basic"
      className="modal-points"
      initialValues={{
        remember: true,
      }}
      autoComplete="off"
      style={{marginTop: "1rem"}}
      form={form}
    >
      <Form.Item
      css={css`
       flex-basis: 50%;
       margin-bottom: 2rem;
      .ant-form-item-explain-error{margin-left: 2rem !important;font-size: 0.8rem}
      `}
        label="Amount"
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 16 }}
        name="amount"
        onKeyDown={(e)=> ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()} 
        rules={[
          {
            required: true,
            message: `Please input amount!`,
          },
        ]}
      >
        <Input type="number"  size="large" css={css`margin-left: 2rem;`}/>
      </Form.Item>

      <Form.Item
        label="payment"
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 16 }}
        name="payment"
        css={css`
            flex-basis: 50%;
           .ant-form-item-explain-error{margin-left: 2rem !important;font-size: 0.8rem}
       `}
        rules={[
          {
            required: true,
            message: `Please input payment method!`,
          },
        ]}
      >
        <Select
          css={css`margin-left: 2rem;`}
          dropdownStyle={{zIndex: 2000}}
          size='large'
          options={paymentMethods}
        />
      </Form.Item>
    </Form>
     ,
      
    });
  };

  const handleReceive = async (close) => {
    console.log("form",form.getFieldsValue())
    try {
        await form.validateFields();
      } catch (error) {
        return;
    }
    setLoading(true);
    close();
    const {amount,payment} = form.getFieldsValue();
    const params = {
        masterId: location.state?.id,
        amount,
        paymentMethod: payment
    }
    const res = await axios.post(`/wallet/setDebtByMasterId`,params)
    if(res.code == 200) form.resetFields();
    setErrorMsg({ code: res.code, msg: res.message })
    setOpenAlert(true)
    fetchData();
  }

    return (
      <div>
    <div>
       <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
       <div style={{display: 'flex',justifyContent: "space-between"}}>
        {/* <div style={{display: 'flex',alignItems: 'center'}}> */}
          {/* <RangePicker
                value={date.startDate ? [dayjs(date.startDate, 'YYYY-MM-DD'), dayjs(date.endDate, 'YYYY-MM-DD')] : ''}
                onChange={(v,dateString)=> handleDateChange(v,dateString)}
          /> */}
        {/* </div>         */}
         <Button style={{ backgroundColor: "rgb(103, 58, 183)",color: 'white',padding: "0 2rem 0 2rem" }} type='dashed' onClick={()=> showTextArea()} >
           Receive
        </Button>
       </div>
      <Table loading={loading} scroll={{ x: 'max-content' }} css={css`padding-top: 2rem;`} pagination={false} columns={columns} dataSource={debts} />
      <Pagination className='pagination' css={css`display: flex;justify-content: end;padding-top: 1rem;`} current={page} total={total} pageSize={10} showSizeChanger={false} onChange={(page) => handlePageChange(page)} />
    </div>
  </div>
  )
}


